import { render } from "./modalStatistics.vue?vue&type=template&id=3c597cd2&scoped=true"
import script from "./modalStatistics.vue?vue&type=script&lang=js"
export * from "./modalStatistics.vue?vue&type=script&lang=js"

import "./modalStatistics.vue?vue&type=style&index=0&id=3c597cd2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/studiostvapp/studiostvapp/PlatformStudiosApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c597cd2"]])

export default __exports__